import React from 'react';
import '../styles/faq.css'; // Make sure to import the CSS file

const faqs = [
  {
    question: "How much does a website cost?",
    answer: "Website costs vary based on requirements. We tailor quotes after assessing your needs."
  },
  {
    question: "How long does it take to build a website?",
    answer: "Most websites are completed within 3–12 weeks, depending on size and functionality. Larger projects may take longer."
  },
  {
    question: "Can I update my website after it's live?",
    answer: "Yes, we build websites that are easy to manage and update even after launch."
  },
  {
    question: "Will my website be mobile friendly?",
    answer: "Absolutely. All our websites are fully responsive and mobile optimized."
  }
];

const FAQ = () => {
  return (
    <section className="faq-section">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-grid">
        {faqs.map((item, index) => (
          <div className="faq-item" key={index}>
            <h3 className="faq-question">{item.question}</h3>
            <p className="faq-answer">{item.answer}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
